// import { ShowFlags } from '@/mapSDK/IMapSdk'

export const ShowFlags = {
  /**
   * 没有任何展示
   */
  None: 0,
  /**
   * 顶部导航条
   */
  Nav: 1 << 0,
  /**
   * 左部图层管理
   */
  Layer: 1 << 1,
  /**
   * 显示点击标注弹窗
   */
  Marker: 1 << 2
  // todo 其他UI控制
}
export class IframeMsgHandler {
  #messageHandMap = null
  #connector = null
  #app = null
  constructor (connector) {
    this.#connector = connector
    this.#messageHandMap = {
      'getLayers': 'onGetLayers',
      'cluster': 'onCluster',
      'showLayer': 'onShowLayer',
      'measure': 'onMeasure',
      'analyse': 'onAnalyse',
      'cancelMeasure': 'onCancelMeasure',
      'cancelWatianfang': 'onCancelWatianfang',
      'cancelKeshiyu': 'onCancelKeshiyu',
      'flyto': 'onFlyTo',
      'showUI': 'onShowUI',
      'getLayerById': 'onGetLayerById'
    }
  }

  setApp (app) {
    this.#app = app
  }

  dispatchMessage (event, data) {
    if (this.#messageHandMap[data.type]) {
      this[this.#messageHandMap[data.type]](event, data)
    }
  }

  onGetLayers (event, msgData) {
    const layerList = this.#app.$store.getters.layerList
    const resData = layerList.map(item => {
      let cluster = false
      let show = false
      if (item.type === 'POINT') {
        if (item.dataSourceType === 'API') {
          const bundle = this.#app.$cesiumPlus.primitiveManager.getBundle(item.id)
          if (bundle) {
            cluster = bundle.enableCluster
            show = bundle.show
          }
        } else {
          cluster = this.#app.$cesiumPlus.markerManager.getClusterState(item.id)
          show = this.#app.$cesiumPlus.markerManager.getDataSourceByLayer(item.id).show
        }
      } else {
        show = this.#app.$cesiumPlus.markerManager.getDataSourceByLayer(item.id).show
      }
      return {
        name: item.name,
        layerId: item.id,
        type: item.type,
        show: show,
        cluster: cluster
      }
    })
    const sendData = {
      type: msgData.type,
      data: resData
    }
    this.#connector.postMessage(sendData)
  }

  onGetLayerById (event, msgData) {
    const data = msgData.data
    const layerItem = this.#app.$store.getters.layerList.find(item => { return Number(item.id) === Number(data.id) })
    let cluster = false
    let show = false
    if (layerItem.type === 'POINT') {
      if (layerItem.dataSourceType === 'API') {
        const bundle = this.#app.$cesiumPlus.primitiveManager.getBundle(layerItem.id)
        if (bundle) {
          cluster = bundle.enableCluster
          show = bundle.show
        }
      } else {
        cluster = this.#app.$cesiumPlus.markerManager.getClusterState(layerItem.id)
        show = this.#app.$cesiumPlus.markerManager.getDataSourceByLayer(layerItem.id).show
      }
    } else {
      show = this.#app.$cesiumPlus.markerManager.getDataSourceByLayer(layerItem.id).show
    }
    const resData = {
      name: layerItem.name,
      layerId: layerItem.id,
      type: layerItem.type,
      show: show,
      cluster: cluster
    }
    const sendData = {
      type: msgData.type,
      data: resData
    }
    this.#connector.postMessage(sendData)
  }

  onCluster (event, msgData) {
    const data = msgData.data
    const layerList = this.#app.$store.getters.layerList
    layerList.forEach(layer => {
      if (layer.id === data.layerId || !data.layerId) {
        if (layer.type === 'POINT') {
          if (layer.dataSourceType === 'API') {
            const bundle = this.#app.$cesiumPlus.primitiveManager.getBundle(layer.id)
            bundle.enableCluster = data.isCluster
          } else {
            this.#app.$cesiumPlus.markerManager.clusterIcon(layer.id, {
              enable: data.isCluster
            })
          }
        }
      }
    })
  }

  onShowLayer (event, msgData) {
    const data = msgData.data
    const layerList = this.#app.$store.getters.layerList
    layerList.forEach(layer => {
      if (layer.id === data.layerId || !data.layerId) {
        if (layer.dataSourceType === 'API') {
          const bundle = this.#app.$cesiumPlus.primitiveManager.getBundle(layer.id)
          bundle.show = data.show
        } else {
          this.#app.$cesiumPlus.markerManager.showMarkerByLayer(layer.id, data.show)
        }
      }
    })
  }

  onMeasure (event, msgData) {
    const data = msgData.data
    if (data.name === 'juli') {
      this.#app.$measureTools.distance()
    } else if (data.name === 'mianji') {
      this.#app.$measureTools.area()
    } else if (data.name === 'watianfang') {
      this.#app.$measureTools.volumeMeasure()
    }
  }

  onAnalyse (event, msgData) {
    const data = msgData.data
    if (data.name === 'tongshi') {
      this.#app.$measureTools.visibilityAnalysis()
    } else if (data.name === 'shiye') {
      this.#app.$measureTools.cameraView()
    } else if (data.name === 'keshiyu') {
      this.#app.$measureTools.viewableAnalysis()
    }
  }

  onCancelMeasure (event, msgData) {
    this.#app.$measureTools.cancel()
    this.#app.$measureTools.clearAllEntity()
  }

  onCancelWatianfang (event, msgData) {
    this.#app.$measureTools.cancelVolumeMeasure()
  }

  onCancelKeshiyu (event, msgData) {
    this.#app.$measureTools.cancelViewableAnalysis()
  }

  onClearMeasure (event, msgData) {
    this.#app.$measureTools.clearAllEntity()
  }

  onFlyTo (event, msgData) {
    const flyEndFunc = (isSucc) => {
      const sendData = {
        type: msgData.type,
        data: {
          isSucc: isSucc
        }
      }
      this.#connector.postMessage(sendData)
    }
    const data = msgData.data
    const options = data.options ?? {}
    options.duration = !isNaN(parseFloat(options.duration)) ? parseFloat(options.duration) : 3
    options.maximumHeight = !isNaN(parseFloat(options.maximumHeight)) ? parseFloat(options.maximumHeight) : undefined
    const offset = options.offset ?? {}
    const heading = !isNaN(parseFloat(offset.heading)) ? parseFloat(offset.heading) : 0
    const pitch = !isNaN(parseFloat(offset.pitch)) ? parseFloat(offset.pitch) : 0
    const range = !isNaN(parseFloat(offset.range)) ? parseFloat(offset.range) : 0
    options.offset = options.offset ? new Cesium.HeadingPitchRange(Cesium.Math.toRadians(heading), Cesium.Math.toRadians(pitch), range) : undefined
    if (typeof data.target === 'object') {
      const lng = !isNaN(parseFloat(data.target.lng)) ? parseFloat(data.target.lng) : 0
      const lat = !isNaN(parseFloat(data.target.lat)) ? parseFloat(data.target.lat) : 0
      const alt = !isNaN(parseFloat(data.target.alt)) ? parseFloat(data.target.alt) : 0
      const position = Cesium.Cartesian3.fromDegrees(lng, lat, alt)
      this.#app.$cesiumPlus.cameraManager.zoomToPosition(position, {
        ...options,
        complete: flyEndFunc(true)
      })
    } else {
      if (data.target && typeof data.target === 'string' && data.target.startsWith('billboard-')) {
        const billboardId = data.target
        const layerId = billboardId.replace('billboard-', '').split('-')[0]
        const bundle = this.#app.$cesiumPlus.primitiveManager.getBundle(parseInt(layerId))
        if (!bundle) {
          flyEndFunc(false)
          return
        }
        const primitive = bundle.getBillboard(billboardId)
        if (!primitive) {
          flyEndFunc(false)
          return
        }
        this.#app.$cesiumPlus.cameraManager.zoomToPosition(primitive.position, {
          ...options,
          complete: flyEndFunc(true)
        })
      } else {
        const marker = this.#app.$cesiumPlus.markerManager.getMarkerById(data.target)
        if (marker) {
          const geoJson = JSON.parse(marker.toGeoJson())
          this.#app.$cesiumPlus.cameraManager.zoomToGeometry(geoJson, {
            ...options,
            complete: flyEndFunc(true)
          })
        } else {
          flyEndFunc(false)
        }
      }
    }
  }

  onShowUI (event, msgData) {
    const flag = msgData.data.flag
    const isHiddenNav = !((flag & ShowFlags.Nav) === ShowFlags.Nav)
    const isHiddenLayer = !((flag & ShowFlags.Layer) === ShowFlags.Layer)
    const isHiddenMarker = !((flag & ShowFlags.Marker) === ShowFlags.Marker)
    this.#app.$store.dispatch('setUIHiddenState', {
      isHiddenNav,
      isHiddenLayer,
      isHiddenMarker
    })
  }
}
